import { IAM } from '../apis';
const reqIAM = IAM('/users');
export const getAll = () => reqIAM('GET', '/?limit=3000');
export const getById = (id) => reqIAM('GET', `/${id}`);
export const update = (id, updated) => reqIAM('PATCH', `/${id}`, { body: updated });
export const create = (user) => reqIAM('POST', `/`, { body: user });
export const addCreditor = (id, relation) => reqIAM('POST', `/${id}/creditors`, { body: relation });
export const removeCreditor = (id, creditorId) => reqIAM('DELETE', `/${id}/creditors/${creditorId}`);
export const addTenant = (id, relation) => reqIAM('POST', `/${id}/tenants`, { body: relation });
export const removeTenant = (id, tenantId) => reqIAM('DELETE', `/${id}/tenants/${tenantId}`);
export const deleteUserById = (id) => reqIAM('DELETE', `/${id}`);
//# sourceMappingURL=users.js.map